"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Store = void 0;
const immer_1 = require("immer");
const isEqual_1 = __importDefault(require("lodash-es/isEqual"));
(0, immer_1.enablePatches)();
(0, immer_1.enableMapSet)();
function createSubscription(store, subscriber, stateSelector) {
    let lastState = store.getCurrentState(stateSelector);
    const queue = [];
    let subscriberIsBusy = false;
    const act = () => {
        const nextState = store.getCurrentState(stateSelector);
        if (!(0, isEqual_1.default)(nextState, lastState)) {
            subscriberIsBusy = true;
            subscriber(nextState, lastState);
            subscriberIsBusy = false;
            lastState = nextState;
        }
    };
    return () => {
        // If a subscriber is still busy, push the action onto a queue.
        // This prevents side-effects from creating infinite loops.
        if (subscriberIsBusy) {
            queue.push(() => act());
            return;
        }
        act();
        // Clear queue
        while (queue.length) {
            const nextAct = queue.shift();
            nextAct === null || nextAct === void 0 ? void 0 : nextAct();
        }
    };
}
class Store {
    _fireSubscribers() {
        this._subscribers.forEach((s) => s());
    }
    constructor(state) {
        this._subscribers = [];
        this.initialState = Object.assign({}, state);
        this.currentState = Object.assign({}, state);
    }
    subscribe(stateSelector, subscriber) {
        const sub = createSubscription(this, subscriber, stateSelector);
        this._subscribers.push(sub);
        const unsub = () => {
            this._subscribers = this._subscribers.filter((s) => s !== sub);
        };
        return unsub;
    }
    resetToInitialState() {
        this.currentState = this.getInitialState();
        this._fireSubscribers();
    }
    update(updater) {
        if (updater instanceof Function) {
            const [result, patches] = (0, immer_1.produceWithPatches)(this.currentState, updater);
            // Don't update or fire subscriptions if nothing changed
            if (!patches.length) {
                return result;
            }
            this.currentState = result;
        }
        else if (typeof updater === 'object') {
            this.currentState = Object.assign({}, updater);
        }
        this._fireSubscribers();
        return this.currentState;
    }
    getInitialState() {
        return Object.assign({}, this.initialState);
    }
    getCurrentState(stateSelector) {
        const currentState = Object.assign({}, this.currentState);
        return stateSelector ? stateSelector(currentState) : currentState;
    }
}
exports.Store = Store;
